import * as React from 'react';
import {useState} from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import {
  BridgeSiteSettings,
  SiteBridgeSettingsForSiteAdminProps
} from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';
import {RemoteRefreshAgents} from '~src/ts/resources/RemoteRefreshAgents';
import {IRemoteAgentConnectionStatus} from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

const initialRemoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[] = [];

/**
 * Creates a settings coordinator with the site bridge settings
 */
export function BridgeSiteSettingsCoordinator(props: SiteBridgeSettingsForSiteAdminProps) {
  const [remoteAgentConnectionStatuses, setRemoteAgentConnectionStatuses] = useState(initialRemoteAgentConnectionStatuses);
  React.useEffect(() => {
    RemoteRefreshAgents.getSiteRemoteAgentsConnectionStatus()
      .then((result: IRemoteAgentConnectionStatus[]) => {
        setRemoteAgentConnectionStatuses(result);
      });
  }, []);

  const newProps: SiteBridgeSettingsForSiteAdminProps = {
    settings: props.settings,
    connectionStatuses: remoteAgentConnectionStatuses
  };

  return (
    <SettingsCoordinator>
      <BridgeSiteSettings {...newProps}/>
    </SettingsCoordinator>
  );
}
